const API_URL = process.env.REACT_APP_BACKEND_URL;

export const trackEvent = (eventType, page = null, walletAddress = null, metadata = null) => {
  try {
    fetch(`${API_URL}/api/events/log`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        wallet_address: walletAddress,
        event_type: eventType,
        page,
        metadata,
      }),
    }).catch(() => {});
  } catch {
    // Silent — analytics should never break the app
  }
};
